import { gql } from "@apollo/client";

export default gql`
  query workspaceSkills($organizationId: Int!) {
    workspaceSkills(organizationId: $organizationId) {
      id
      name
      slug
      description
      body
      visibility
      canEdit
      canArchive
      updated
      created
    }
  }
`;
